<template>
    <div class="wrapper">
        <div class="row">
            <div class="col-12">
                <table class="table table-striped table-sm">
                    <thead>
                    <tr>
                        <th>Status</th>
                        <th>Actief tot</th>
                        <th>Naam</th>
                        <th>E-mail</th>
                        <th>Type</th>
                        <th>Bedrijven</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in items">
                        <td align="center"><small><i v-if="item.nopw == '1'" class="fa fa-lock" style="color: red"></i>
                            <i v-else-if="item.actief == '1'" class="fa fa-unlock" style="color: green"></i>
                            <i v-else variant="secondary" class="fa fa-moon-o" style="color: orange"></i></small></td>
                        <td>{{datumDDMMYYYY(item.einddatum)}}</td>
                        <td>{{item.voornaam}} {{item.naam}}</td>
                        <td>{{item.email}}</td>
                        <td>{{item.typeuser.naam}}</td>
                        <td>{{bedrijven(item)}}</td>
                        <td nowrap>
                            <router-link :to="'/beheer/account/activate/' + item.id" title="Account activeren"><i class="fa fa-unlock"></i></router-link>
                            &nbsp;
                            <router-link :to="'/beheer/account/edit/' + item.id" title="Account wijzigen"><i class="fa fa-pencil-square-o"></i></router-link>
                            &nbsp;
                            <a href="javascript:void(0)" @click="bevestigItem(item.id, item.voornaam + ' ' + item.naam)"  title="Account verwijderen"><i class="fa fa-trash"></i></a>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <nav>
                    <ul class="pagination">
                        <li class="page-item"><router-link class="page-link" to="/beheer/account/new">Account toevoegen</router-link></li>
                    </ul>
                </nav>
            </div><!--/.col-->
        </div><!--/.row-->

        <b-modal title="Verwijderen" size="sm" v-model="warningModal" @ok="deleteItem">
            Account <b>{{name}}</b> wordt verwijderd. Bent u zeker?
        </b-modal>
    </div>
</template>

<script>
    import datefunctions from '../../helpers/datefunctions';

    export default {
        name: 'List',
        props: ['items'],
        data () {
            return {
                id: -1,
                name: '',
                warningModal: false,
            };
        },
        methods: {
            bedrijven (item) {
                let resultaat = '';
                item.tuinderbedrijf_n.forEach((tuinderbedrijf) => {
                    resultaat += `${tuinderbedrijf.bedrijf.naam} | `;
                });
                return resultaat.substring(0, resultaat.length - 3);
            },
            bevestigItem (id, name) {
                this.id = id;
                this.name = name;
                this.warningModal = true;
            },
            deleteItem () {
                this.warningModal = false;
                this.$emit('delete-item', this.id);
            },
            datumDDMMYYYY (datum) {
                return datefunctions.datetoDDMMYYYY(datum);
            },
        },
    };
</script>



// WEBPACK FOOTER //
// src/pages/account/List.vue